module.exports = __webpack_public_path__ + "static/media/intro.293d5e66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/intro.jpg
// module id = 483
// module chunks = 0